import { getDocumentId } from 'src/utils/mongo/getDocumentId';
import { TASK_FOLLOW_UP_ACTION } from 'src/modules/assistant/constants/actions';
import { createActionHandler } from 'src/modules/assistant/actions/createActionHandler';
import { TCreateTaskDraft } from 'src/modules/assistant/actions/types';
import { isFutureDate } from 'src/modules/assistant/helpers/isFutureDate';

export const createTask = createActionHandler<TCreateTaskDraft>({
    fields: [['description', 'Assistant.ActionFieldDescription', true]],
    schedulable: true,
    validate: (draft) =>
        Boolean(draft.description?.trim()) && isFutureDate(draft.scheduledAt),
    execute: (draft, { lead, leadActions }) =>
        leadActions.createTaskV2({
            lead: lead._id,
            actions: [TASK_FOLLOW_UP_ACTION],
            substatus: getDocumentId(lead.substatus),
            date: draft.scheduledAt,
            isActive: false,
            comment: draft.description,
            isAssistantGenerated: true,
        }),
});
